import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from '../reducers/users.reducer';
import { USERS_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<UsersState>(USERS_FEATURE_KEY);

export const selectUsers = createSelector(selectState, (state: UsersState) => state.users);
export const selectLoaded = createSelector(selectState, (state: UsersState) => state.loaded);
export const selectLoading = createSelector(selectState, (state: UsersState) => state.loading);
export const selectQuery = createSelector(selectState, (state: UsersState) => state.query);
export const selectPage = createSelector(selectState, (state: UsersState) => state.page);
export const selectTotal = createSelector(selectState, (state: UsersState) => state.total);
export const selectLookupLoaded = createSelector(selectState, (state: UsersState) => state.lookupLoaded);
export const selectLookup = createSelector(selectState, (state: UsersState) => state.lookup);
export const selectLookupOptions = createSelector(selectLookup, (lookup) => lookup.map((user) => ({ label: user.name, value: user.id })));
